import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { MessageEditor } from "@/components/MessageEditor";
import { api, formatError } from "@/lib/api";

export default function AdminMessages() {
  const [form, setForm] = useState({ pickup_message: "", reminder_message: "" });
  const [defaults, setDefaults] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/settings").then((r) => {
      setForm({ pickup_message: r.data.pickup_message, reminder_message: r.data.reminder_message });
      setDefaults(r.data.defaults);
    }).catch((e) => toast.error(formatError(e)));
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/admin/settings", form);
      toast.success("Mensagens salvas");
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setBusy(false);
    }
  };

  const valid = form.pickup_message.trim().length >= 5 && form.reminder_message.trim().length >= 5;
  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl font-extrabold tracking-tight">Mensagens do WhatsApp</h1>
          <p className="text-slate-500">Clique numa etiqueta para inseri-la. Ela é trocada pelos dados reais do pedido.</p>
        </div>
        <Button onClick={save} disabled={busy || !valid} className="bg-[#0099DD] hover:bg-sky-700" data-testid="btn-save-messages">{busy ? "Salvando..." : "Salvar mensagens"}</Button>
      </div>
      <MessageEditor id="pickup-message" title="Aviso de retirada" hint="Enviado quando o pedido fica disponível para retirada."
        value={form.pickup_message} onChange={(v) => setForm((f) => ({ ...f, pickup_message: v }))} defaultValue={defaults.pickup_message} />
      <MessageEditor id="reminder-message" title="Lembrete de retirada" hint="Enviado para pedidos esperando retirada há mais de 3 dias." withDate
        value={form.reminder_message} onChange={(v) => setForm((f) => ({ ...f, reminder_message: v }))} defaultValue={defaults.reminder_message} />
    </div>
  );
}
